module.exports = __webpack_public_path__ + "static/media/icon-password-blue.635494fb.svg";